/**
 * Where modal windows (booking, cancel, admin slot, login, new password) are rendered.
 *
 * Standalone (app.claystudio.sk) they go straight to document.body. Embedded in the
 * Hostinger page, embed.tsx registers a separate container on document.body, outside the
 * page's layout: inside Hostinger's grid the overlay ended up under the sticky header and
 * Safari sent clicks on its buttons to a Hostinger element (QA 2026-10-24).
 */
let modalRoot: HTMLElement | null = null;

export function setModalRoot(el: HTMLElement): void {
  modalRoot = el;
}

export function getModalRoot(): HTMLElement {
  return modalRoot ?? document.body;
}
